export default () => ({
  currentIndex: 0,

  selectNextSibling() {
    const cards = this.$refs.cards.querySelectorAll('[class*="card"]')
    if (this.currentIndex < cards.length - 1) {
      this.currentIndex = this.currentIndex + 1
    }
    cards[this.currentIndex].querySelector('a')?.focus()
    this.$refs.cards.scrollLeft = cards[this.currentIndex].offsetLeft
  },

  selectPreviousSibling() {
    const cards = this.$refs.cards.querySelectorAll('[class*="card"]')
    if (this.currentIndex > 0) {
      this.currentIndex = this.currentIndex - 1
    } else {
      this.currentIndex = 0
    }
    cards[this.currentIndex].querySelector('a')?.focus()
    this.$refs.cards.scrollLeft = cards[this.currentIndex].offsetLeft
  },
})
